
export default {
  props: {
    flagType: {
      type: String,
      default: ''
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      flagData: {
        deliveryToday: {
          icon: 'ico-delivery-today',
          alt: '오늘출발'
        },
        deliveryTomorrow: {
          icon: 'ico-delivery-tomorrow',
          alt: '내일출발'
        },
        deliveryClosing: {
          icon: 'ico-delivery-tomorrow',
          alt: '오늘출발마감'
        },
        arriveToday: {
          icon: 'ico-arrive-today',
          alt: '오늘도착'
        },
        arriveTomorrow: {
          icon: 'ico-arrive-tomorrow',
          alt: '내일도착'
        },
        deliveryHoliday: {
          icon: 'ico-delivery-holiday',
          alt: '휴일도착'
        },
        pickupToday: {
          icon: 'ico-pickup-today',
          alt: '오늘픽업'
        },
        pickupTomorrow: {
          icon: 'ico-pickup-tomorrow',
          alt: '내일픽업'
        },
      }
    }
  }
}
